module.exports = __webpack_public_path__ + "static/media/iconPreinscription.ed038d5a.svg";